export default __webpack_public_path__ + "static/media/coins.9d5dbcac.svg";